import React from 'react';
import cn from 'classnames';
import { Badge, Button, Icon } from '@sravni/react-design-system';
import { ArrowDown, Check } from '@sravni/react-icons';
import { Heading } from '../../../../../landing.common/heading';
import styles from './styles.module.scss';

type Props = {
    title: string;
    subTitle: string;
    imgIcon?: React.ReactNode;
    opened?: boolean;
    completed?: boolean;
    onClickOpen?: () => void;
    children?: React.ReactNode;
};

export const StepWrapper = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
    const { title, subTitle, imgIcon, opened, completed, onClickOpen, children } = props;

    return (
        <div ref={ref} className={cn(styles.root, { [styles.opened]: opened })}>
            {opened ? (
                <div>
                    <Badge variant="primary" text={title} />
                    <Heading className={styles.heading} level={5}>
                        {subTitle}
                    </Heading>
                    {children}
                </div>
            ) : (
                <div className={styles.wrapperClosed}>
                    {completed ? (
                        <div className={styles.stepImageCompleted}>
                            <Check />
                        </div>
                    ) : (
                        <div className={styles.stepImage}>{imgIcon}</div>
                    )}
                    <div>
                        {title}. {subTitle}
                    </div>
                </div>
            )}
            {completed && (
                <Button onClick={onClickOpen} variant="text">
                    <Icon icon={<ArrowDown />} />
                </Button>
            )}
        </div>
    );
});

StepWrapper.displayName = 'StepWrapper';
